import { SubscriptionPlanDetailsDto } from 'src/com/sixdee/crbtportal/core/dto/subscriptionplandetails/subscriptionplandetailsdto';
import { APIFeatures } from 'src/com/sixdee/crbtportal/core/util/apifeatures';
import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';
import { AlertType } from '../../../../toolkit/alert/alerttype';
import { UIComponentHandler, UIComponentImpl, UIComponentProps, UIComponentState } from '../../../../toolkit/uicomponent';
import { APIModelHandler, APIModel } from '../../../../toolkit/uicomponentapimodel';
import { UIComponentCSSStyle } from '../../../../toolkit/uicomponentcss';
import { UIComponentView } from '../../../../toolkit/uicomponentview';
import { FlashMessageDto } from 'src/com/sixdee/crbtportal/core/dto/flashmessage/get/flashmessagedto';
import { SubscriptionFlashMessageComponentViewImpl } from './flashsubscriptionview';
import { SubscriptionFlashMessageComponentAPIModel, SubscriptionFlashMessageComponentAPIModelImpl } from './flashsubsciptionapimodel';
import { SubscriptionFlashMessageComponentCSSStyleImpl } from './flashsubscriptioncss';

export interface SubscriptionFlashMessageComponentProps extends UIComponentProps {
    flashMessageDto: FlashMessageDto;
    channel?: string;
    closePopup(): void;
    showOTPPopUp(flashMessageDto: FlashMessageDto): void;
    showPopup(id: string, msg: string, type: AlertType): void;
}

export interface SubscriptionFlashMessageComponentState extends UIComponentState {
    isMonthlyHovered: boolean;
    isWeeklyHovered: boolean;
    isDailyHovered: boolean;
    onPackselected: string;
}

export interface SubscriptionFlashMessageComponentHandler extends UIComponentHandler {

    onMonthlyHovered(isMonthlyHovered: boolean, isWeeklyHovered: boolean, isDailyHovered: boolean): void;
    onMonthlyHoveredExit(): void;
    onWeeklyHovered(isMonthlyHovered: boolean, isWeeklyHovered: boolean, isDailyHovered: boolean): void;
    onWeeklyHoveredExit(): void;
    onDailyHovered(isMonthlyHovered: boolean, isWeeklyHovered: boolean, isDailyHovered: boolean): void;
    onDailyHoveredExit(): void;
    onCancelClick(): void;
    onConfirmClick(): void;
    onClick(packName: string): void;

}

export class SubscriptionFlashMessageComponent extends UIComponentImpl<SubscriptionFlashMessageComponentProps, SubscriptionFlashMessageComponentState, SubscriptionPlanDetailsDto>
    implements SubscriptionFlashMessageComponentHandler {
    constructor(props: SubscriptionFlashMessageComponentProps) {
        super(props);

        this.state = {
            isMonthlyHovered: false,
            isDailyHovered: true, isWeeklyHovered: false, onPackselected:
                props.context.getConfigurationSettings().getProperty("NOTE4U_DAILY_OFFER_CODE")
        };
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<SubscriptionPlanDetailsDto> {
        return new SubscriptionFlashMessageComponentViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle {
        return new SubscriptionFlashMessageComponentCSSStyleImpl(applicationContext);
    }


    protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel {
        return new SubscriptionFlashMessageComponentAPIModelImpl(applicationContext, apiModelHandler);
    }
    onMonthlyHovered(isMonthlyHovered: boolean, isWeeklyHovered: boolean, isDailyHovered: boolean): void {
        this.setState({ isMonthlyHovered: isMonthlyHovered, isWeeklyHovered: isWeeklyHovered, isDailyHovered: isDailyHovered });
    }
    onMonthlyHoveredExit(): void {
        this.setState({ isMonthlyHovered: false });
    }
    onWeeklyHovered(isMonthlyHovered: boolean, isWeeklyHovered: boolean, isDailyHovered: boolean): void {
        this.setState({ isMonthlyHovered: isMonthlyHovered, isWeeklyHovered: isWeeklyHovered, isDailyHovered: isDailyHovered });
    }
    onWeeklyHoveredExit(): void {
        this.setState({ isWeeklyHovered: false });
    }
    onDailyHovered(isMonthlyHovered: boolean, isWeeklyHovered: boolean, isDailyHovered: boolean): void {
        this.setState({ isMonthlyHovered: isMonthlyHovered, isWeeklyHovered: isWeeklyHovered, isDailyHovered: isDailyHovered });
    }
    onDailyHoveredExit(): void {
        this.setState({ isDailyHovered: false });
    }

    onCancelClick(): void {
        this.props.closePopup();
    }

    onConfirmClick(): void {
        this.props.flashMessageDto.setPlanName(this.state.onPackselected);
        if (this.getContext().getUserContext().getIsLoggedIn()) {
            (this.getView() as SubscriptionFlashMessageComponentViewImpl).showLoader();

            this.props.flashMessageDto.getIsAllCallers() ?
                (this.getAPIModel() as SubscriptionFlashMessageComponentAPIModel).setFlashMessage(this.props.flashMessageDto)
                :
                (this.getAPIModel() as SubscriptionFlashMessageComponentAPIModel).setSpecialCallerFlashMessage(this.props.flashMessageDto);
        }
        else {
            (this.getView() as SubscriptionFlashMessageComponentViewImpl).showLoader();
            (this.getAPIModel() as SubscriptionFlashMessageComponentAPIModel).generateOTP(this.props.flashMessageDto);
        }
    }


    onClick(packName: string): void {
        this.setState({ onPackselected: packName });
    }

    onSuccess(feature: APIFeatures, description: string, data: any): void {
        (this.getView() as SubscriptionFlashMessageComponentViewImpl).dismissLoader();

        if (feature === APIFeatures.SET_FLASH_MESSAGE) {
            this.props.showPopup(this.getContext().getResources().getString(Strings.subscription),
                this.getContext().getResources().getString(Strings.your_order_is_successfully_completed), AlertType.SUCCESS);

        }
        if (feature === APIFeatures.DEDICATE_FLASH_MESSAGE) {
            this.props.showPopup(this.getContext().getResources().getString(Strings.subscription),
                this.getContext().getResources().getString(Strings.your_order_is_successfully_completed), AlertType.SUCCESS);

        }
        else if (feature === APIFeatures.GENERATE_OTP) {
            this.props.showOTPPopUp(this.props.flashMessageDto);
        }
    }

    onFailure(feature: APIFeatures, description: string, data: any): void {
        (this.getView() as SubscriptionFlashMessageComponentViewImpl).dismissLoader();
        this.props.showPopup("Note4U Subscription", description, AlertType.ERROR);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/flashmessage/flashsubscription/flashsubscriptioncomponent.tsx